/* eslint-disable array-element-newline */
import 'extensions/ui-components/g-modal';
import 'extensions/ui-components/x-message';
import {PageManager} from 'genesis-packages/core';
import './LOGN.scss';

/**
 * @typedef SSOMessageDataError
 * @prop {number} count
 * @prop {string[]} messages
 */

/**
 * @typedef SSOMessageData
 * @prop {'SSO'} type
 * @prop {boolean} success
 * @prop {string} url
 * @prop {Record<string, any>} params
 * @prop {SSOMessageDataErrors} error
 */


/**
 * @param {string} action
 * @param {Record<string, any>} formData
 * @param {string[]} formDataKeyAllowList
 */
const redirectWithPostData = (action, formData, formDataKeyAllowList = ['SSO_Login', 'Session_ID', 'Customer_Session_ID']) => {
	const form = document.createElement('form');
	form.setAttribute('method', 'post');
	form.setAttribute('action', action);

	for (let key in formData) {
		if (!formDataKeyAllowList.includes(key)) {
			continue;
		}

		const hiddenInput = document.createElement('input');
		hiddenInput.setAttribute('type', 'hidden');
		hiddenInput.setAttribute('name', key);
		hiddenInput.setAttribute('value', formData[key]);

		form.appendChild(hiddenInput);
	}

	document.body.appendChild(form);
	form.requestSubmit();
};

export default class LOGN extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		// Add event listener to listen to posted messages from the iframe
		this.handleMessage = this._handleMessage.bind(this);
		window.addEventListener('message', this.handleMessage, false);
	}

	/**
	 * Event handler for iframe messages via window.postMessage. Used for SSO login redirects.
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
	 * @param {MessageEvent<SSOMessageData>} e
	 */
	_handleMessage (e) {
		// Only allow redirect messages from self
		if (e.origin === window.location.origin && e.data.type === 'SSO') {
			if (e.data.success) {
				redirectWithPostData(e.data.url, e.data.params);
			}
			else {
				// Close modal
				const modal = document.getElementById('js-login-modal');
				modal.close();

				// Clear messages container
				const messagesContainer = document.getElementById('messages');
				messagesContainer.innerHTML = '';

				// Inject error messages into "messages" div
				for (let message of e.data.error.messages) {
					const xMessage = document.createElement('x-message');
					xMessage.type = 'error';
					xMessage.innerHTML = message;

					messagesContainer.appendChild(xMessage);
				}
			}
		}
	}

};
